/** Shared auth vocabulary + tiny email helpers (the backend enforces access). */

export type Role = "SUPER_ADMIN" | "MEMBER";
export type UserStatus = "ACTIVE" | "DISABLED";
export type DisplayStatus = "Pending" | "Active" | "Disabled";

export function normalizeEmail(raw: string): string {
  return raw.trim().toLowerCase();
}

export function isValidEmail(raw: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizeEmail(raw));
}
